export default "__VITE_ASSET__DOEirTAW__"